// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  identity: __t.identity().primaryKey(),
  hp: __t.i32(),
  maxHp: __t.i32().name("max_hp"),
  lastStrikeAt: __t.timestamp().name("last_strike_at"),
  lastHurtAt: __t.timestamp().name("last_hurt_at"),
  updatedAt: __t.timestamp().name("updated_at"),
});
